import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'fixedPriceType'
})
export class FixedPriceTypePipe implements PipeTransform{
    constructor() { }
  transform(items: any[], typeFilter: string): any[] {
      if (!items || !typeFilter) {
        return items;
      }
      return items.filter(item => item.type === typeFilter);
    }
}